import { useLocation } from 'react-router-dom';
import './Header.scss';
import useIsMobile from '../../../hooks/useIsMobile';

type HeaderProps = {
  title?: string;
  subtitle?: string;
  component?: React.ReactNode;
};

const Header = ({ title, subtitle, component }: HeaderProps) => {
  const isMobile = useIsMobile();
  const location = useLocation();

  const isMessageThreadPage = (() => {
    const threadIdPattern = /[^/]+\.msg\.Message\.\d+$/;
    return threadIdPattern.test(location.pathname);
  })();

  if (isMobile && isMessageThreadPage) {
    return null;
  }

  return (
    <div className='app__header'>
      <div>
        <h1 className='app__header-title'>{title || ''}</h1>
        <h2 className='app__header-subtitle'>{subtitle || ''}</h2>
      </div>
      {component}
    </div>
  );
};

export default Header;
